import styled, { SimpleInterpolation, keyframes } from 'styled-components';
import { Colors, Media, Shadows } from 'enums';
import { ZIndex } from 'config';

const popupAnimation = keyframes`
 0% { opacity: 0; transform: 0 }
 100% { opacity: 1; transform: 1 }
`;

export const ModalStyled = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 20px;
  background-color: rgba(0, 0, 0, 0.16);
  z-index: ${ZIndex.ModalWindow};

  animation-name: ${popupAnimation};
  animation-duration: 0.5s;
  animation-iteration-count: 1;
`;

export const ModalContentStyled = styled.div<{
  customStyles?: SimpleInterpolation;
}>`
  position: relative;
  display: flex;
  background-color: ${Colors.white};
  box-shadow: ${Shadows.lightShadow};

  width: 320px;
  padding: 32px;
  border-radius: 8px;

  ${({ customStyles }) => customStyles}

  @media ${Media.notebook} {
    width: 520px;
    padding: 56px;
    border-radius: 10px;

    ${({ customStyles }) => customStyles}
  }
`;

export const CloseButtonStyled = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;

  @media ${Media.notebook} {
    top: 20px;
    right: 20px;
  }
`;
